import Cookies from 'js-cookie';
export const save = async (url, data: any) => {

    const token = Cookies.get('token')

    try {
        const res = await fetch(url, {
                method: 'post', 
                body: JSON.stringify({... data}), 
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token,
                },
                //@ts-ignore-next-line
                duplex: 'half',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                redirect: 'follow',
            }).then(res => res.json())

        if(res.success) {
            return res;
        }

        console.error('save error', { url, data, errorCode: res.status, error: res.errors ? res.errors : [`Server error: ${res.statusText}`] })
        return { success: false, errors: res.errors ? res.errors : [`Server error: ${res.statusText}`] };
    } catch (error) {
        console.error('save catch error', { url, error})
        return {
            success: false,
            errors: [`Unexpected error: ${error.toString()}`],
        };
    }

    
}
export default save;